<template>
  <a-modal
    :visible.sync="isVisible"
    :confirmLoading="loading"
    :okButtonProps="{ props: {disabled: false} }"
    :maskClosable="false"
    title="修改密码"
    :bodyStyle="isMobile() ? { margin: 'auto 20px' } : { margin: 'auto 50px' }"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form" layout="vertical">
      <a-form-item label="旧密码" class="password-form-item">
        <a-input
          type="password"
          autocomplete="false"
          placeholder="请输入旧密码"
          v-decorator="['oldPass', {
            rules: [{ required: true, message: '请输入正在使用的密码' }],
            validateTrigger: 'blur'
          }]">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item label="新密码" class="password-form-item">
        <a-input
          type="password"
          autocomplete="false"
          placeholder="请输入8-20位新密码"
          v-decorator="['newPass', {
            rules: [{ required: true, message: '请输入新密码' },
                    { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/, message: '密码必须是8-20位数字与字母的组合' }],
            validateTrigger: 'blur'
          }]">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item label="重复新密码" class="password-form-item">
        <a-input
          type="password"
          autocomplete="false"
          placeholder="重复新密码"
          v-decorator="['repeatNewPass', {
            rules: [{ required: true, message: '请重复输入密码' }, { validator: handleRepeatNewPass }],
            validateTrigger: 'blur'
          }]">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { updatePassword } from '@/api/user'
import { mapGetters } from 'vuex'
import { mixinDevice } from '@/utils/mixin'

export default {
  mixins: [mixinDevice],

  props: {
    visible: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      spinning: false,
      state: {
        time: 60,
        smsSendBtn: false
      }
    }
  },

  computed: {
    isVisible: {
      get: function () {
        return this.visible
      },
      set: function (val) {
        this.$emit('update:visible', val)
      }
    }
  },

  watch: {},

  methods: {
    ...mapGetters(['userInfo']),

    handleOk () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          updatePassword(values).then(response => {
            this.$message.success(response.msg)
            this.isVisible = false
            this.$emit('onUpdated', values.newPass)
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            this.loading = false
          })
        } else {
          console.log(err)
          this.loading = false
        }
      })
    },

    handleCancel () {
      this.isVisible = false
    },

    handleRepeatNewPass (rule, value, callback) {
      const { getFieldValue } = this.form
      if (value && value !== getFieldValue('newPass')) {
        callback('两次输入的密码不一致！')
      }
      // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
      callback()
    }
  }
}
</script>

<style scoped>
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .password-form-item {
    margin-bottom: 10px;
  }
</style>
